"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    EmphasisRow: ()=>EmphasisRow
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../components/Text/index.cjs");
function EmphasisRow({ Story }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: "grid grid-cols-3 gap-2",
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "bg-primary-1 border-primary-3 h-fit rounded-md border-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.P, {
                            textStyle: "body2",
                            align: "center",
                            className: "propValue mb-2",
                            children: [
                                "regular emphasis",
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                                "contrast bg"
                            ]
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "grid grid-rows-3 gap-4",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Story, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "bg-primary-3 border-primary-3 h-fit rounded-md border-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.P, {
                            textStyle: "body2",
                            align: "center",
                            className: "propValue mb-2",
                            children: [
                                "medium emphasis",
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                                "contrast bg"
                            ]
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "grid grid-rows-3 gap-4",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Story, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "bg-primary-12 border-primary-12 h-fit rounded-md border-2 p-4",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.P, {
                            align: "center",
                            className: "propValue text-primary-1 mb-2",
                            children: [
                                "bold emphasis",
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                                "contrast bg"
                            ]
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "grid grid-rows-3 gap-4",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Story, {})
                        })
                    ]
                })
            ]
        })
    });
}
exports.EmphasisRow = __webpack_exports__.EmphasisRow;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "EmphasisRow"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
